import { render, staticRenderFns } from "./CellValidateLabel.vue?vue&type=template&id=238407b2&"
import script from "./CellValidateLabel.vue?vue&type=script&lang=js&"
export * from "./CellValidateLabel.vue?vue&type=script&lang=js&"
import style0 from "./CellValidateLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports